import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaDownload, FaStore } from "react-icons/fa";
import SEO from "../components/SEO";
import { DOWNLOAD_URL, games } from "../data/siteCatalog";
import "../style/GamesPage.css";

export default function GamesPage() {
  return (
    <section className="games-page">
      <SEO
        title="Giochi Kyros | Zombie Crushers, WarFront, Ghost Hunter"
        description="Tutti i giochi Kyros: cosa puoi giocare, comprare o seguire oggi."
        canonical="https://kyrosgames.com/games"
      />

      <header className="games-page__hero">
        <span className="games-page__eyebrow">Giochi</span>
        <h1>Tutti i giochi Kyros</h1>
        <p>
          Da qui vedi subito cosa puoi fare: giocare gratis, leggere una scheda prodotto,
          aprire lo Store o seguire un playtest.
        </p>
        <div className="games-page__actions">
          <Link to="/store" className="games-page__action games-page__action--primary">
            <FaStore aria-hidden="true" />
            <span>Apri lo Store</span>
          </Link>
          <a href={DOWNLOAD_URL} download className="games-page__action games-page__action--secondary">
            <FaDownload aria-hidden="true" />
            <span>Scarica launcher</span>
          </a>
        </div>
      </header>

      <div className="games-page__grid">
        {games.map(game => (
          <article key={game.id} className="games-card">
            <div className="games-card__media">
              <img src={game.image} alt="" />
              <span>{game.status}</span>
            </div>
            <div className="games-card__body">
              <div>
                <h2>{game.name}</h2>
                <p>{game.summary}</p>
              </div>
              <dl className="games-card__facts">
                <div>
                  <dt>Dove</dt>
                  <dd>{game.storeStatus}</dd>
                </div>
                <div>
                  <dt>Stato</dt>
                  <dd>{game.leaderboardStatus}</dd>
                </div>
              </dl>
              <Link to={game.route} className="games-card__link">
                <span>{game.secondaryCta}</span>
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
